export const HEADERS_ARRAY = [
	[<th colSpan={8}>Claims to do</th>],
	[
		<th>Product</th>,
		<th>To pay</th>,
		<th>To check</th>,
		<th>Check in progress</th>,
		<th>Overdue</th>,
	],
];
